module.exports = __webpack_public_path__ + "img/en.58255c19.png";